<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-4 w-100">
      <h4 class="title"><i class="fas fa-window-restore"></i> {{entityName | translate}}</h4>
    </div>
    <div class="col-md-2 mt-4 content-position-end">
      <button type="button"
              class="btn btn-outline-success font-weight-bold custom-button mw-180"
              (click)="openAddModal()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-2 custom-mr-17">
    <label class="font-weight-bold ">{{ "LABEL.OPERATING-SYSTEM" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fab fa-windows"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="operatingsystemSelected"
              (ngModelChange)="reloadInstallers()">
        <option *ngFor="let operatingsystem of operatingsystems"
                [ngValue]="operatingsystem">{{operatingsystem.description | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-17">
    <label class="font-weight-bold">{{ "LABEL.FILE-TYPE" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fas fa-file"></i></div>
      </div>
      <select class="form-control ml-1 mr-2"
              [(ngModel)]="typefileSelected"
              (ngModelChange)="reloadInstallers()">
        <option *ngFor="let typeFile of typefiles" [ngValue]="typeFile">{{typeFile.description | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-17">
    <label class="font-weight-bold">{{ "LABEL.APPLICATION-TYPE" | translate }}:</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fab fa-app-store"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="signatureAppTypeSelected"
              (ngModelChange)="reloadInstallers()">
        <option *ngFor="let signatureAppType of signatureAppTypes"
                [ngValue]="signatureAppType">{{signatureAppType.shortdescription | translate}}</option>
      </select>
    </div>
  </div>
  <!--</div>-->
  <!--<div class="form-inline mt-2">-->
  <div class="col-md-3 custom-mr-17">
    <label class="font-weight-bold">{{ "LABEL.VERSION" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fab fa-vimeo-v"></i></div>
      </div>
      <input type="text"
             id="searchInput"
             class="form-control"
             placeholder="{{ 'MESSAGE.ENTER-TO-SEARCH' | translate }}"
             [(ngModel)]="term2Search"
             (keyup.enter)="search()">
    </div>
  </div>
  <div class="col-md-2 custom-mt-24">
    <button type="button"
            class="btn btn-outline-success custom-button"
            [disabled]="term2Search === undefined"
            (click)="search()"><i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
    </button>
  </div>
</div>
<div class="table-responsive mt-2 mb-2 custom-table-height">
  <table class="table-sm table-bordered">
    <thead>
    <tr>
      <th scope="col" title="#"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.OPERATING-SYSTEM' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.FILE-TYPE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.APPLICATION-TYPE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.VERSION' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let installer of installers; let index=index">
      <td title="#"><b>{{(page.number * 10) + index + 1}}</b></td>
      <td title="{{ 'TABLE.HEADER.OPERATING-SYSTEM' | translate }}">
        <span class="{{installer._more.operatingsystemId == 1 ? 'badge badge-info':'badge badge-secondary'}}">
          {{getTypesOperatingSystemDescription(installer._more.operatingsystemId)}}
        </span>
      </td>
      <td title="{{ 'TABLE.HEADER.FILE-TYPE' | translate }}">
        <span class="{{installer.typefile == 1 ? 'badge badge-info':'badge badge-secondary'}}">
          {{getTypesFileDescription(installer.typefile)}}
        </span>
      </td>
      <td title="{{ 'TABLE.HEADER.APPLICATION-TYPE' | translate }}">
        <span class="badge badge-info">
        {{getInstallerDescription(installer._more.typeApp)}}
        </span>
      </td>
      <td title="{{ 'TABLE.HEADER.VERSION' | translate }}">{{installer.version}}</td>
      <td title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}">
        <span class="badge badge-info"
              data-toggle="tooltip"
              data-placement="bottom"
              title="{{ 'MESSAGE.REVIEW-DESCRIPTION' | translate }}"
              (click)="viewDescription(installer)">{{ "BUTTON.VIEW" | translate }}
        </span></td>
      <td title="{{ 'TABLE.HEADER.DATE' | translate }}">{{installer.createAt | dateformat}}</td>
      <td title="{{ 'TABLE.HEADER.STATE' | translate }}"><span
        class="{{!installer.active? 'badge badge-danger':''}}">{{installer.active ? ('TABLE.HEADER.ACTIVE' | translate) : ('TABLE.HEADER.INACTIVE' | translate)}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
        <div class="dropdown">
          <button type="button" class="btn btn-default " id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button class="dropdown-item poniter"
                    (click)="download(installer)">
              <i class="fa fa-file-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
            </button>
            <button class="dropdown-item poniter"
                    (click)="openEditModal(installer)">
              <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
            </button>
            <button class="dropdown-item pointer"
                    (click)="openModalDelete(installer)">
              <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
            </button>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<nav class="Page navigation pagination-custom">
  <div class="row">
    <div class="col-md-8 mt-1">
      <div class="justify-content-row">
        <label class="mr-1 font-weight-normal">Mostrar </label>
        <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                (ngModelChange)="loadInstallers(enumPage.First)">
          <option *ngFor="let page of pageNumbers" [value]="page.value"
                  class="font-weight-bold">{{page.value}}</option>
        </select>
        <label class="font-weight-normal"> registros.</label>
      </div>
      <div class="page-total-entries">
        {{ "LABEL.TOTAL-RECORDS" | translate }}
        : {{installers.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
      </div>
    </div>
    <div class="col-md-4">
      <ul class="pagination justify-content-end text-center">
        <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
          <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadInstallers(enumPage.First)"
             tabindex="-1" aria-disabled="true">
            <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
            {{ "BUTTON.FIRST" | translate }}
          </a>
        </li>
        <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
          <a class="left" (click)="loadInstallers(enumPage.Previous)">
            <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="right" (click)="loadInstallers(enumPage.Next)"><i
            class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
            (click)="loadInstallers(enumPage.Last)">
          <a class="next">
            {{ "BUTTON.LAST" | translate }}
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<app-loading *ngIf="loading"></app-loading>
